import { CircularProgress, Grid } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import DeviceInfo from "./DeviceInfo";
import DeviceConnect from "./DeviceConnect";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { notify } from "../../../utils/notify";
import { updatePhoneUsage } from "../../../repositories/portal_api/ConectaZap";
import { ConectaZapContext } from "../context/ConectaZapContext";
import { socket } from "../socket/socket";
import { addInstance, getInstances } from "../service/ConectaZapService";

const TabPanelAccounts = () => {
  const [chatAlreadySelected, setChatAlreadySelected] = useState(false);
  const [notificationAlreadySelected, setNotificationAlreadySelected] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const { companyUser } = useContext(GlobalContext);
  const { instancesConectaZap, setInstancesConectaZap, setLoadingPage } =
    useContext(ConectaZapContext);

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Conectado ao servidor!");
    });

    socket.on("disconnect", () => {
      console.log("Desconectado do servidor");
    });

    let listTopics = [];

    if (instancesConectaZap?.length > 0) {
      listTopics = instancesConectaZap.map((instance) => {
        return {
          topicName: `cnpj/${companyUser.document}/instance/${instance.id}/on-connect`,
          instanceId: instance.id,
        };
      });

      listTopics.forEach((topic) => {
        socket.on(topic.topicName, (value) => {
          const eventJson = JSON.parse(value);
          updateInstanceConnection(topic.instanceId, eventJson?.status);
        });
      });

      socket.connect();
    }

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      listTopics.forEach((topic) => {
        socket.off(topic.topicName);
      });
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, [instancesConectaZap]);

  useEffect(() => {
    const initialSetup = async () => {
      let instances = await getInstances(companyUser.document);

      if (instances?.length === 0) {
        instances = await addInstance(companyUser.document);
      }

      if (instances?.length > 0) {
        instances.forEach((instance) => {
          if (instance?.flags?.chat) {
            setChatAlreadySelected(true);
          }
          if (instance?.flags?.notifications) {
            setNotificationAlreadySelected(true);
          }
        });
      }

      setLoading(false);

      setInstancesConectaZap(instances);
    };

    initialSetup();

    // eslint-disable-next-line
  }, []);

  async function updateInstance({ instance, value, type }) {
    let copyIntances = [...instancesConectaZap];

    setLoadingPage(true);

    if (type === "chat") {
      setChatAlreadySelected(value);
    }

    if (type === "notifications") {
      setNotificationAlreadySelected(value);
    }

    try {
      const response = await updatePhoneUsage(
        companyUser.document,
        instance.phoneNumberId,
        type,
        value
      );

      if (response?.success) {
        copyIntances.map((instanceCopy) => {
          if (instanceCopy.id === instance.id) {
            if (type === "chat") {
              instanceCopy.flags.chat = value;
            } else if (type === "notifications") {
              instanceCopy.flags.notifications = value;
            }
          }

          return instanceCopy;
        });

        setInstancesConectaZap(copyIntances);
      } else {
        if (type === "chat") {
          setChatAlreadySelected(!value);
        }

        if (type === "notifications") {
          setNotificationAlreadySelected(!value);
        }

        notify("Erro ao atualizar uso do telefone", true, "error");
      }
    } catch (e) {
      notify("Erro ao atualizar uso do telefone", true, "error");
    } finally {
      setLoadingPage(false);
    }
  }

  function updateInstanceConnection(instanceId, status) {
    if (status === "deleted") {
      let copyIntances = [...instancesConectaZap];

      copyIntances = copyIntances.filter((instance) => {
        return instance.id !== instanceId;
      });

      setInstancesConectaZap(copyIntances);
    } else {
      let copyIntances = [...instancesConectaZap];

      copyIntances.map((instance) => {
        if (instance.id === instanceId) {
          instance.status = status ? "connected" : "disconnected";
        }

        return instance;
      });

      setInstancesConectaZap(copyIntances);
    }
  }

  return (
    <>
      {instancesConectaZap?.length > 0 ? (
        instancesConectaZap.map((instance) => {
          return (
            <Grid
              container
              style={{
                marginTop: 16,
                background: "#fff",
                border: "1px solid #E0E0E0",
                borderRadius: 15,
                padding: 16,
              }}
            >
              <>
                <Grid item xs={12} sm={12} md={6}>
                  <DeviceInfo
                    instance={instance}
                    updateInstance={updateInstance}
                    alreadySelectedChat={chatAlreadySelected}
                    alreadySelectedNotification={notificationAlreadySelected}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <DeviceConnect
                    instance={instance}
                    updateInstanceConnection={updateInstanceConnection}
                    setLoadingPage={setLoadingPage}
                  />
                </Grid>
              </>
            </Grid>
          );
        })
      ) : loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div> Nenhuma instância cadastrada</div>
      )}
    </>
  );
};

export default TabPanelAccounts;
